module.exports = __webpack_public_path__ + "static/approves3-9144bd3322ca98959d327b92e39f778e.gif";